module.exports = __webpack_public_path__ + "img/vip-pic3.b11d4c22.png";